import type { FC } from 'react';
import { Route, Routes } from 'react-router-dom';
import { PageLoginVerificationCode } from '@app/pages/LoginVerificationCode';
import { PageLogin } from '@app/pages/Login';

export const LoginSwitch: FC = () => (
  <Routes>
    <Route
      path="/:userId/:verificationCode"
      element={<PageLoginVerificationCode />}
    />
    <Route path="/" element={<PageLogin />} />
  </Routes>
);
